import { render } from "./PackageCard.vue?vue&type=template&id=66b5fa87&scoped=true"
import script from "./PackageCard.vue?vue&type=script&lang=js"
export * from "./PackageCard.vue?vue&type=script&lang=js"

import "./PackageCard.vue?vue&type=style&index=0&id=66b5fa87&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Efren Bustos\\source\\repos\\VDAI\\vdai\\ClientApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66b5fa87"]])

export default __exports__